@import '@evisort/eds-tokens/spacing.css';

/*
 * Layout modifiers compose on the root: base + flex + direction/spacing + optional
 * align, justify, wrap. Class suffixes use semantic steps (`spacing-xs` → `--eds--spacing-4`, etc.);
 * `gap` uses pixel-named spacing tokens. Use `var(--eds--padding-*)` for
 * inset on a single box (e.g. Button, Chip), not for flex `gap` here.
 */

.eds-layout {
  box-sizing: border-box;
  display: flex;
}

.eds-layout--flex-none {
  flex: none;
}

.eds-layout--flex-auto {
  flex: 1 1 auto;
}

.eds-layout--flex-1 {
  flex: 1;
}

.eds-layout--flex-0 {
  flex: 0;
}

.eds-layout--wrap {
  flex-wrap: wrap;
}

.eds-layout--align-center {
  align-items: center;
}

.eds-layout--align-start {
  align-items: flex-start;
}

.eds-layout--align-end {
  align-items: flex-end;
}

.eds-layout--align-stretch {
  align-items: stretch;
}

.eds-layout--align-baseline {
  align-items: baseline;
}

.eds-layout--justify-center {
  justify-content: center;
}

.eds-layout--justify-start {
  justify-content: flex-start;
}

.eds-layout--justify-end {
  justify-content: flex-end;
}

.eds-layout--justify-between {
  justify-content: space-between;
}

.eds-layout--justify-around {
  justify-content: space-around;
}

.eds-layout--justify-evenly {
  justify-content: space-evenly;
}

.eds-layout--direction-row--spacing-xs {
  flex-direction: row;
  gap: var(--eds--spacing-4);
}

.eds-layout--direction-row--spacing-s {
  flex-direction: row;
  gap: var(--eds--spacing-8);
}

.eds-layout--direction-row--spacing-m {
  flex-direction: row;
  gap: var(--eds--spacing-16);
}

.eds-layout--direction-row--spacing-l {
  flex-direction: row;
  gap: var(--eds--spacing-24);
}

.eds-layout--direction-row--spacing-xl {
  flex-direction: row;
  gap: var(--eds--spacing-32);
}

.eds-layout--direction-row--spacing-none {
  flex-direction: row;
  gap: var(--eds--spacing-none);
}

.eds-layout--direction-column--spacing-xs {
  flex-direction: column;
  gap: var(--eds--spacing-4);
}

.eds-layout--direction-column--spacing-s {
  flex-direction: column;
  gap: var(--eds--spacing-8);
}

.eds-layout--direction-column--spacing-m {
  flex-direction: column;
  gap: var(--eds--spacing-16);
}

.eds-layout--direction-column--spacing-l {
  flex-direction: column;
  gap: var(--eds--spacing-24);
}

.eds-layout--direction-column--spacing-xl {
  flex-direction: column;
  gap: var(--eds--spacing-32);
}

.eds-layout--direction-column--spacing-none {
  flex-direction: column;
  gap: var(--eds--spacing-none);
}
